import { createTrackingUtils } from "../index.js";
export const flights_funnel_sr_page_size_increase_desktop = createTrackingUtils({
    name: "flights_funnel_sr_page_size_increase_desktop",
    defaultStage: 1,
    stages: {
        main: 1
    },
    goals: {},
    goalsWithValue: []
});
